/* MENU */
const nav = document.querySelector(".wp-block-navigation");
const burgerBtn = nav?.querySelector(
  ".wp-block-navigation__responsive-container-open",
);
const container = nav?.querySelector(
  ".wp-block-navigation__responsive-container",
);
const submenuItems = nav?.querySelectorAll("li.wp-block-navigation-submenu");
const header = document.querySelector("header");
const BREAKPOINT = 1024;
const isMobile = () => window.innerWidth < BREAKPOINT;

if (burgerBtn && container) {
  burgerBtn.addEventListener("click", () => {
    container.classList.toggle("is-menu-open");
    header.classList.toggle("is-menu-open");
  });
}

submenuItems?.forEach((item) => {
  item.addEventListener("click", (e) => {
    if (!isMobile()) return;

    const link = item.querySelector("a.wp-block-navigation-item__content");
    if (link && link.contains(e.target)) e.preventDefault();

    e.stopPropagation();

    const isOpen = item.classList.contains("is-submenu-open");
    document
      .querySelectorAll("li.wp-block-navigation-submenu.is-submenu-open")
      .forEach((el) => {
        if (el !== item) el.classList.remove("is-submenu-open");
      });

    item.classList.toggle("is-submenu-open", !isOpen);
  });
});

const relocateResponsiveContainer = () => {
  if (!container || !header) return;
  if (isMobile()) {
    if (container.parentNode !== document.body)
      document.body.appendChild(container);
  } else {
    if (container.parentNode !== nav) nav.appendChild(container);
  }
};

relocateResponsiveContainer();
window.addEventListener("resize", () => {
  relocateResponsiveContainer();
  if (!isMobile() && container?.classList.contains("is-menu-open")) {
    container.classList.remove("is-menu-open");
  }
});

/* END MENU */
